<template>
    <div class="incsall">
        <!--功能列-->
        <div class="btare">
            <div class="backrul">
                <a href="javascript:void(0)" @click="gotoList()"> 
                    返回查詢結果
                </a>
            </div>
        </div>
        <div class="language_div p-3 mb-2">
            <button id="toTw" :class="'btn '+(this.lang == '1' ?'btn-danger selected':'btn-secondary')" @click="toLang('tw')">中文版</button>
            <button id="toEn" :class="'btn '+(this.lang == '2' ?'btn-danger selected':'btn-secondary')" @click="toLang('en')">英文版</button>
        </div>
        <!--標題區塊-->
        <div class="title_div p-3 mb-2 bkbor">
            <label class="text-danger" for="title">標題*</label>
            <b-form-input 
                name="title"
                placeholder="請輸入標題"
                required
                maxlength="200" v-model="content.title">
            </b-form-input>
        </div>
         <!--設定區塊-->
        <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" >
            <b-row>
                <b-col>
                    <label class="text-danger" for="startDate">上架時間*</label>
                    <b-form-datepicker 
                        name="startDate"
                        class="mb-2"  
                        clear-button
                        placeholder="選擇上架日期" 
                        v-model="content.startDate"
                        :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                    </b-form-datepicker>
                </b-col>
                <b-col>
                    <label for="endDate">下架時間</label>
                    <b-form-datepicker 
                        name="endDate"
                        class="mb-2"  
                        reset-button
                        reset-button-text="清除日期"
                        placeholder="選擇下架日期" 
                        v-model="content.endDate"
                        :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                    </b-form-datepicker>
                </b-col>
                <b-col>
                    <label>排序</label>
                    <b-form-input
                    type="number"
                    min=0
                    class="nospin"
                    v-model="content.sort">
                    </b-form-input>
                </b-col>
                <b-col>
                    <label class="text-danger" for="Displaystatus">發布狀態*</label>
                    <b-form-select 
                        name="Displaystatus"
                        class="only-button-down"
                        v-model="content.deployStatus"
                        :options="statusOption">
                    </b-form-select>
                </b-col>
            </b-row>
        </b-form-group>
        <b-row>
            <b-col>
                <label class="text-danger">圖片上傳* (建議上傳尺寸 W:1100 x H:590 px)</label>
                <div>
                    <b-form-file
                    accept=".jpg,.png"
                    v-model="content.file"
                    ref="file-input"
                    class="mb-2"
                    placeholder="尚未選擇任何檔案"
                    browse-text="選擇檔案">
                    </b-form-file>
                </div>
            </b-col>
            <b-col>
                <label>網址</label>
                <div>
                    <b-form-input
                    v-model="content.url"
                    class="mb-2"
                    placeholder="請輸入網址">
                    </b-form-input> 
                </div>
            </b-col>
        </b-row>
        <b-row v-if="content.filePath">
            <b-col>
                <label>預覽</label>
                <div class="rulnal">
                    <div class="viewvd">
                        <img :src="'/filestore'+content.filePath" alt="imgPathError" width="640" onerror="this.src='../../images/default.jpg'"></img>
                    </div>
                </div>
            </b-col>
        </b-row>

        <!--紀錄區-->
        <b-form-group
            label-size="lg"
            class="p-3 mb-2 bg-secondary text-white mt-3"
            style="opacity: 0.75;"
            v-if=" content.creatorName || content.modifierName">
          
            <b-row v-if="content.creatorName">
                建檔記錄：{{content.creatorName}} ({{ datetimeFormatFloat(content.createDate) }})
            </b-row>
            <b-row v-if="content.modifierName">
                異動紀錄：{{content.modifierName}} ({{ datetimeFormatFloat(content.modifyDate) }})
            </b-row>
        </b-form-group>
        <!--功能操作區-->
        <div class="mt-3 mb-3" >
            <b-button @click="save" >
                儲存
            </b-button>
        </div>
    </div>
</template>
<script>
export default{
    components:{
    },
    data(){
        return{
            formData: new FormData(),
            //類別編號
            PJ_ID:"",
            typeId: "",
            //文章編號
            id:"", 
            //語系
            lang:"",
            //樣式編號
            modal:"",
            //文章內容
            content:{
                title:"",
                startDate:"",
                endDate:"",
                deploystatus:null,
                file:"",
                filePath:"",
                creatorName:"",
                createDate:"",
                modifierName:"",
                modifyDate:"",
            },
            //發布狀態選項
            statusOption:[
                {value:null,text:"請選擇"},
                {value:0,text:"關閉"},
                {value:1,text:"開啟"},
            ],
            //初始化中
            isInit:true,
            //異動警告
            isEdited:false,
            //是否更新
            isUpdate:false,
            //API設定區
            apiBanner:(data) => this.userRequest.post("bicd/Banner2",data),
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        value(){
            //初始化
            this.init();
        },
        content(){
            if(!this.isInit){
                //判斷資料內容是否有變更
                //this.isEdited = true;
            }
        }
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //類別內部編號
            this.typeId = this.value.typeId;
            //文章編號
            this.id = this.value.id;
            //語系
            this.lang = this.value.lang?this.value.lang : "1";
            //樣式編號
            this.modal = this.value.modal;
            //是否為修改
            this.isUpdate = false;
            //取得文章內容
            this.getContent(); 

            
        },
        //取得內容資料
        async getContent(){
            try {
                //POST 參數
                let jsonReq = {
                    TYPE: "GetContent",
                    banner_SELECT:{
                        bannerId:this.id,
                        langurage: Number(this.lang),
                    }
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Banner",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    if (json.Data != "null"){
                        //有資料時，讀取資料並切換成修改模式
                        let jsonData =JSON.parse(json.Data);
                        this.content = {
                            id: jsonData.bannerID,
                            title:jsonData.title,
                            startDate:jsonData.startDate,
                            endDate:jsonData.endDate,
                            file:null,
                            filePath:jsonData.filePath,
                            deployStatus:jsonData.deployStatus,
                            description:jsonData.description,
                            sort: jsonData.sort,
                            url: jsonData.url,
                            creatorName:jsonData.creatorName,
                            createDate:jsonData.createDate,
                            modifierName:jsonData.modifierName,
                            modifyDate:jsonData.modifyDate,
                        };
                        this.id = jsonData.bannerID;
                        //更改狀態為修改
                        this.isUpdate = true;
                    }else{
                        //預設空值
                        this.content = {
                            id:0,
                            title:"",
                            startDate:"",
                            endDate:"",
                            deployStatus:null,
                            file:null,
                            url:"",
                            sort:1,
                            description:"",
                            creatorName:"",
                            createDate:"",
                            modifierName:"",
                            modifyDate:"",
                        };
                        //更改狀態為新增
                        this.isUpdate = false
                    }
                }
            }catch(err){
                console.log("ErrorFunction: getContent/n "+err);
            }
        },
        //儲存
        save(){
            //將目前資訊整合，並送出
            this.formData = new FormData();
            this.formData.append("VerifyCode",this.PJ_ID);
            this.formData.append("bannerId",(this.id)?this.id:0);
            this.formData.append("startDate",this.content.startDate);
            this.formData.append("endDate",this.content.endDate);
            this.formData.append("title",this.content.title);
            this.formData.append("sort",this.content.sort);
            this.formData.append("url",this.content.url);
            this.formData.append("deployStatus",this.content.deployStatus);
            this.formData.append("langurage",Number(this.lang));
            this.formData.append("httpPostedFile",this.content.file?this.content.file:null);
            if(this.isUpdate){
                //修改功能
                this.formData.append("TYPE","UPDATE");
                this.FunctionToken(this.functionUpdate,this.formData);
            }else{
               //新增功能
                this.formData.append("TYPE","INSERT");
                this.FunctionToken(this.functionInsert,this.formData);
            }
           
        },
        //新增功能
        functionInsert(data){
            this.formData.append("Token",data.Token);
            this.apiBanner(data)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status){
                        //this.$bvToast.toast("新增成功",{title:"提示",solid:true,});
                        alert("新增成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示                        
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err) =>{
                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //更新功能
        functionUpdate(data){
            this.formData.append("Token",data.Token);
            this.apiBanner(data)
                .then((res) => {
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        //this.$bvToast.toast("更新成功",{title:"提示",solid:true,});
                        alert("更新成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err)=>{

                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //切換語系
        toLang(click_lang){
            
            if(click_lang == 'tw' && this.lang != '1'){
                //進入中文介面 
               /* if (this.isEdited){
                    //確認是否不儲存就離開
                    if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                        return;
                    }
                }*/
                this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=1");
                
            }else if(click_lang == 'en'&& this.lang != '2'){
                //進入英文介面
                /*if(this.isEdited){
                    //確認是否不儲存就離開
                    if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                        return;
                    }
                }*/
                this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=2");
            }
        },
        //跳轉至列表頁面
        gotoList(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:2,
                }
            });
        },
    }   
}
</script>